<template>
  <div>
    <div class="shade" v-if="isLoading">
      <div class="flexJC alignItem showLoading">
        <img src="../../static/images/Spinner_1.gif" alt="" class="icon_loading" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 微信网页授权
 */
import wxServ from '../service/wxServ'
import cache from '../service/cacheServ'
import userServ from '../service/userServ'
import mintUi from '../lib/mint-ui'
import log from '../lib/log'
export default {
  name: 'login',
  data() {
    return {
      isLoading: false
    }
  },
  async created() {

    log.info({ loc: 'login.vue#created', contents: { query: this.$route.query }, qrcode: 1171 })
    // 如果连接中有微信返回的 code，则用此 code 调用后端接口，向微信服务器请求用户信息
    // 如果不是从微信重定向过来的，没有带着微信的 code，则直接进入首页
    let code = this.$route.query.code;
    let qrCode = this.$route.query.qrcode;
    let bedNo = this.$route.query.bedNo;
    if (userServ.IsWeixinOrAlipay() == 'WeiXIN') {
      if (code) {
        var that = this;
        that.isLoading = true;
        userServ.loginByCode(code).then(function (res) {
          that.isLoading = false;
          if (res.code === '200') {
            that.$router.push({ path: '/', query: { qrcode: qrCode, bedNo } })
          } else {
            mintUi.Toast({
              message: res.message,
              position: 'bottom'
            })
          }
        })
      } else {
        that.$router.push({ path: '/', query: { qrcode: qrCode, bedNo } })
      }
    } else if (userServ.IsWeixinOrAlipay() == 'Alipay') { // 支付宝进入
      if (code) {
        var that = this;
        that.isLoading = true;
        userServ.zfbLoginByCode(code).then((res) => {
          that.isLoading = false;
          if (res.code === '200') {
            that.$router.push({ path: '/', query: { qrcode: qrCode, bedNo } })
          } else {
            mintUi.Toast({
              message: res.message,
              position: 'bottom'
            })
          }
        }).catch((res) => {
          console.log('catch' + res);
          that.isLoading = false;
        })
      } else {
        that.$router.push({ path: '/', query: { qrcode: qrCode, bedNo } })
      }
    } else {
      mintUi.Toast({
        message: '请用微信/支付宝扫码，谢谢',
        position: 'bottom'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../less/_var.less";
@import "../less/index.less";
.icon_loading {
  width: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue